import { client } from "./client";

const ROUTES = {
  getConnector: docId => `/companydbs_detail/${docId}/`,
  getPermissions: companyId => `/companydb_permission/${companyId}/`,
  create_default_cdb_training: '/create_default_cdb_training/',
  config_user_for_use_inmatic: '/config_user_for_use_inmatic/',
  checkCompany: company_id => `/check_company/${company_id}/`,
  //patchConnector: docId => `/companydbs/${docId}/`,
  //listDocuments: ({ limit, offset, state, id, company_id, filters, kind }) => `documents/?company_id=${company_id}${!!kind?`&kind=${kind}`: ''}${!!id?`&id=${id}`: ''}${!!limit?`&limit=${limit}`: ''}${!!offset?`&offset=${offset}`: ''}${!!state?`&state=${state}`: ''}${!!filters?`${filters}`: ''}`,
};

export const connector = {
  getConnector: ({ id }) => {
    return client.get(ROUTES.getConnector(id));
  },
  getPermissions: ({ id }) => {
    return client.get(ROUTES.getPermissions(id));
  },
  create_default_cdb_training:() => {
    return client.post(ROUTES.create_default_cdb_training)
  },
  config_user_for_use_inmatic:() => {
    return client.post(ROUTES.config_user_for_use_inmatic);
  },
  checkCompany: ({ company_id ,route}) => {
    if (company_id) {
      return client.post(ROUTES.checkCompany(company_id),{route});
    }
  }
  
};